import dayjs from 'dayjs';

// Pass param to make it relative
// Do not pass param to get from current date
export const getDayIndexAsMondayFirst = (date?: string) => {
  const day = dayjs(date ? date : undefined).day(); // starts from Sunday 0-6
  return day === 0 ? 6 : day - 1;
};
